import {
	ROVO_INLINE_INPUT_BOX_CLIENT_ID,
	InlineInputBoxAbortMessageCommand,
	ROVO_CHAT_CLIENT_ID,
} from '@atlassian/rovo-content-bridge-api-commands';
import { useRovoContentBridgeAPI } from '@atlassian/rovo-content-bridge-api/hooks';

/**
 * Hook to handle discarding Rovo inline input box operations.
 *
 * @returns { abort: () => void } - Function to abort Rovo inline input box operations.
 */
export const useRovoAbort = () => {
	const { send } = useRovoContentBridgeAPI(ROVO_INLINE_INPUT_BOX_CLIENT_ID);

	return {
		abort: () => {
			send(InlineInputBoxAbortMessageCommand, {
				receiverId: ROVO_CHAT_CLIENT_ID,
			});
		},
	};
};
